module.exports = function(ads) {
  "use strict";
	ads
    .controller('bannerSliderController', bannerSliderController)

	bannerSliderController.$inject = ["jQuery","config","$http", "$rootScope","$scope","getDataService","$state", "refreshtokenService","alertService","$timeout","postDataService","serverError", "API_URL","createRandomHash","authtokenService", "offlineError"];
	
  function bannerSliderController(jQuery,config,$http,$rootScope,$scope,getDataService,$state,refreshtokenService, alertService, $timeout, postDataService,serverError, API_URL,createRandomHash, authtokenService, offlineError) {
    var vmbs = this;
    vmbs.config = config;
    var token = authtokenService.getToken();
    vmbs.widgetItems= [];
    vmbs.requiredTitle = false;
    vmbs.dropzone = {};
    vmbs.requiredField = {
      url:{},
      images:{
        incorect:{},
        mob:{},
        des:{}
      }
    }
    vmbs.removeImage = function(item,type) {
      delete item.images[type];
    }
    vmbs.removeItem= function(index) {
      if(vmbs.widgetItems.length==1) {
        alertService('danger','Opps! ', 'Minimum number of items is 1.')
        return
      }
      vmbs.widgetItems.splice(index,1)
      alertService('success','Success ', 'Banner slider item has been deleted.', 2000);
      $timeout(function() {
        vmbs.saveChanges()
      },0)
    }
    function initalizedDropzone(item) {
      vmbs.dropzone[item.id]={
        dzOptions : {
          url :API_URL+'upload/banner-slider',
          paramName : 'photo',
          maxFilesize : '500',
          parallelUploads: 100,
          acceptedFiles : 'image/jpeg, images/jpg, image/png',
          addRemoveLinks : true,
          autoProcessQueue : false,
          dictInvalidFileType: 'This file type is not supported.',
          dictFileTooBig:'File size too Big',
          headers:{
            'x-auth': token  
          }
        }
      }
      vmbs.dropzone[item.id].dzCallbacks = {
        'addedfile' : function(file){
          vmbs.requiredField.images.incorect[item.id] = false;
          if((file.name.includes('-des.jpg') || file.name.includes('-mob.jpg'))) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                token = authtokenService.getToken();
                vmbs.dropzone[item.id].dzOptions.headers['x-auth'] = token;
                vmbs.dropzone[item.id].dzMethods.processQueue();
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else {
            vmbs.dropzone[item.id].dzMethods.removeFile(file);
            vmbs.requiredField.images.incorect[item.id] = true;
          }
        },
        'success' : function(file, xhr, response){
          var data = JSON.parse(response.currentTarget.response);
          if(data.des && file.name.includes('-des.jpg')) {
            item.images.des = data.des
            vmbs.requiredField.images.des[item.id] = false;
          } else if(data.mob && file.name.includes('-mob.jpg')){
            item.images.mob = data.mob
            vmbs.requiredField.images.mob[item.id] = false;
          }
          $timeout(function() {
            vmbs.dropzone[item.id].dzMethods.removeFile(file);
          },1000)
        },
        'error' : function(file,message) {
          if(message && message.error && message.error.message) {
            jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
          }
        },
        'sending':function(file, xhr, formData) {
        }
      }
    }
    vmbs.addItem = function() {
      var item = {
        url:'',
        id: createRandomHash(10),
        images:{}
      }
      vmbs.widgetItems.push(item)
      vmbs.requiredField.url[item.id] = false;
      vmbs.requiredField.images.incorect[item.id] = false;
      vmbs.requiredField.images.des[item.id] = false;
      vmbs.requiredField.images.mob[item.id] = false; 
      initalizedDropzone(item)
    }
    function validateProp(arr) {
      var validate = true;
      if(!vmbs.bannerSliderTitle) {
        validate = false;
        vmbs.requiredTitle = true;
      } else {
        vmbs.requiredTitle = false;
      }
      for(var i = 0;i<arr.length;i++) {
        if(!arr[i].url) {
          validate = false
          vmbs.requiredField.url[arr[i].id] = true;
        } else {
          vmbs.requiredField.url[arr[i].id] = false;
        }
        if(!arr[i].images.des) {
          validate = false
          vmbs.requiredField.images.des[arr[i].id] = true;
        } else {
          vmbs.requiredField.images.des[arr[i].id] = false;
        }
        if(!arr[i].images.mob) {
          validate = false
          vmbs.requiredField.images.mob[arr[i].id] = true;
        } else {
          vmbs.requiredField.images.mob[arr[i].id] = false;
        }

      }
      if(!validate) return false;
      return true
    }
    function deleteOrUpdateProp(arr) {
      for(var i = 0;i<arr.length;i++) {
        delete arr[i].order;
        delete arr[i].id;
        if(arr[i].image) {
          arr[i].image = arr[i].image['_id']
        }
      }
    } 
    vmbs.saveChanges = function() {
      var widget = angular.copy(vmbs.widgetItems)
      if(!validateProp(widget)) return  
      $rootScope.hasLoaded = false;
      deleteOrUpdateProp(widget)
      var updateData = {
        'title': vmbs.bannerSliderTitle,
        'items':widget
      }
      var postFunction = function() {
        postDataService.save({
          param1:'widgets', 
          param2: 'banner-slider', 
        },updateData).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                postFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction();
    }
    var getFunction = function() { 
      getDataService.get({
        param1: 'widgets',
        param2: 'banner-slider'   
      }).$promise.then(function(data){
        vmbs.widgetItems = data.items;
        for(var i = 0; i<vmbs.widgetItems.length;i++) {
          vmbs.widgetItems[i].id = createRandomHash(10);
          vmbs.requiredField.url[vmbs.widgetItems[i].id] = false;
          initalizedDropzone(vmbs.widgetItems[i])
        }
        vmbs.bannerSliderTitle = data.title;
      },function(error){
        if(!window.navigator.onLine) {
          offlineError('refresh')
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {   
                getFunction();
              }
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        }else if(error.status ==502) {
          serverError()
        }else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }  
      });
    }
    getFunction();
  } 
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/bannerSlider/js/bannerSliderController.js
// module id = 479
// module chunks = 0